import { RootState } from '@client/redux/types';

export const getCustomer = (state: RootState) => state.customer;
export const getCustomerFashionPreferences = (state: RootState) =>
    state.customer?.fashionPreferences?.preferences?.find(pref => pref.key === 'LOUNGE')?.value;
export const isCustomerFetching = (state: RootState) => getCustomer(state).isFetching;
export const isCustomerInitialized = (state: RootState) => getCustomer(state).isInitialized;
export const getEmail = (state: RootState) => state.customer.email;
export const getFirstName = (state: RootState) => state.customer.firstName;
export const getLastName = (state: RootState) => state.customer.lastName;
export const getEventSecrets = (state: RootState) => state.customer.eventSecrets;
export const getGender = (state: RootState) => state.customer.gender;
export const getMyFilter = (state: RootState) => state.customer.myFilter;
export const getCurrency = (state: RootState) => state.customer.currency;
export const getIsLoggedIn = (state: RootState) => state.customer.isLoggedIn;
export const getHashedCustomerNumber = (state: RootState) => state.customer.hashedCustomerNumber;
export const getCountryOfResidence = (state: RootState) => state.customer.countryOfResidence;
export const getIsSubscribedToNewsletter = (state: RootState) => state.customer.nwlSubscription; // TODO: remove if we don't use it
export const getHasOrders = (state: RootState) => state.customer.countedCustomerOrders > 0;
export const getEmailProvider = (state: RootState) => state.customer.emailProvider;
export const getPreferredCountry = (state: RootState) => state.customer.preferredCountry;
export const getHasEmailConfirmed = (state: RootState) => state.customer.mailConfirmed;
export const getCustomerRole = (state: RootState) => state.customer.role;
export const getCustomerAcr = (state: RootState) => state.customer.acr; // to be used for tracking
export const getAreCredentialsCompromised = (state: RootState) =>
    state.customer.areCredentialsCompromised;

// PLUS
export const getPlus = (state: RootState) => getCustomer(state).plus;
export const getLoyalty = (state: RootState) => getCustomer(state).loyalty;
